import * as InvestorActions from './../actions/investor.actions';
import * as SystemActions from 'src/app/store/system/actions/system.actions';
import { IInvestorState, initialInvestorState } from '../../state/investor.state';

export function InvestorReducer(state = initialInvestorState, action: InvestorActions.InvestorActions | SystemActions.SystemActions): IInvestorState {
    switch (action.type) {
        case InvestorActions.LOAD_INVESTOR_BANK_ACCOUNT_SUCCESS:
            return {
                ...state,
                details: {
                    ...state.details,
                    bankAccount: action.payload
                }
            };
        case InvestorActions.SAVE_INVESTOR_DETAILS:
            return {
                ...state,
                investorUpdateStatus: {
                    ...initialInvestorState.investorUpdateStatus,
                    isLoading: true,
                }
            };
        case InvestorActions.LOAD_INVESTOR_ENTITY_SUCCESS:
            return {
                ...state,
                details: {
                    ...action.payload
                }
            };
        case InvestorActions.SAVE_INVESTOR_DETAILS_SUCCESS:
            return {
                ...state,
                details: {
                    ...action.payload
                },
                investorUpdateStatus: {
                    ...state.investorUpdateStatus,
                    isLoading: false,
                    updateSuccess: true
                }
            };
        case InvestorActions.SAVE_INVESTOR_DETAILS_FAIL:
            return {
                ...state,
                details: {
                    ...action.payload
                },
                investorUpdateStatus: {
                    ...state.investorUpdateStatus,
                    isLoading: false,
                    updateFail: true
                }
            };
        case InvestorActions.RESET_TAX_DETAILS_FORM:
            return {
                ...state,
                investorUpdateStatus: {
                    ...state.investorUpdateStatus,
                    isLoading: false,
                    updateFail: false,
                    updateSuccess: false
                }
            };        
        case InvestorActions.LOAD_INVESTOR_ADVISOR_DETAILS_SUCCESS:
            return {
                ...state,
                advisorInformation : action.payload
            }
        case SystemActions.CLEAR_SYSTEM:
            return initialInvestorState;
        default:
            return state;
    }
}
